"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACDivContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ACDivContainer = function (props) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: props.className, style: __assign({}, props.style), onClick: props.onClick, children: [props.label && typeof props.label === 'string' ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { className: props.labelClassName, children: props.label }), props.fillText1] })) : ((0, jsx_runtime_1.jsx)("p", { className: props.labelClassName, children: props.label })), props.required ? (0, jsx_runtime_1.jsx)("span", { style: { color: 'red' }, children: "*" }) : ''] }));
};
exports.ACDivContainer = ACDivContainer;
